import { UserCohort } from 'owa-bizchat-types/lib/UserCohort';
import { getUserCohort } from 'owa-sidepane-bizchat-store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

/**
 * This function determines if the user falls into the category of "Starter" or "MSA" user.
 * In the context of getSuggestions(), those users should not have any SUAs shown to them
 * in the mail tab (no e-mail selected) scenario.
 */
export function isUserStarterOrMSA(): boolean {
    const mailboxInfo = getModuleContextMailboxInfo();
    const userCohort = getUserCohort(mailboxInfo);
    const isStarterUser = !isConsumer() && userCohort === UserCohort.BCWAF;
    const isMSAUser =
        isConsumer() && (userCohort === UserCohort.BCWAF || userCohort === UserCohort.BCAIS);
    return isStarterUser || isMSAUser;
}
